import { HttpService } from 'services/HttpService';
import { SensorModel } from 'pages/TimeseriesPage/SensorModel';

export class TimeseriesService {
  static baseUrl = '/frontend/context-manager';

  static async getAssociatedSensors(powerplantName: string): Promise<SensorModel[]> {
    return HttpService.get(`${TimeseriesService.baseUrl}/context/sensors?associations=${powerplantName}`);
  };

  static async getSensors(): Promise<SensorModel[]> {
    return HttpService.get(`${TimeseriesService.baseUrl}/context/sensors`);
  };

  static async updateAssociations(powerplantId: string, body: {sensors: {id: string, associate: boolean}[]}): Promise<any> {
    const url = `${TimeseriesService.baseUrl}/context/plant/sensors?id=${powerplantId}`
    return HttpService.put(url, body);
  }
}
